export default __webpack_public_path__ + "static/media/refresh.d51b9a5a.svg";